/**
 * event handler for subnav back button on mobile
 * @param {*} e
 */
export function handleSubnavBack(e) {
  const self = e.currentTarget;
  self.parentElement.parentElement.classList.remove("active");
}

/**
 * event handler for subnav clear button on mobile
 * @param {*} e
 */
export function handleSubnavClear(e) {
  const self = e.currentTarget;
  const allCb = self.parentElement.parentElement.querySelectorAll("input[type=checkbox]");
  allCb.forEach(checkbox => {
    checkbox.checked = false;
    checkbox.indeterminate = false;
  });
}
